/**
 * Insctance of EffectCommand
 * @class EffectCommand
 */
export default class PasteCommand {
  /**
   * Constructor
   */
  constructor(target) {
    this.label = 'paste'
    this.target = target
    this.cloneObject = null
  }

  execute() {
    const canvas = this.target.canvas
    this.target.clipBoard.clone(clonedObj => {
      canvas.discardActiveObject()
      clonedObj.set({
        left: clonedObj.left + 10,
        top: clonedObj.top + 10,
        evented: true
      })
      if (clonedObj.type === 'activeSelection') {
        clonedObj.canvas = canvas
        clonedObj.forEachObject(obj => {
          canvas.add(obj)
        })
        clonedObj.setCoords()
      } else {
        canvas.add(clonedObj)
      }
      this.target.clipBoard.top += 10
      this.target.clipBoard.left += 10
      this.cloneObject = clonedObj
      canvas.setActiveObject(clonedObj)
      canvas.bringToFront(this.target.vLine)
      canvas.bringToFront(this.target.hLine)
      this.target.emit('addItem', clonedObj)
      canvas.requestRenderAll()
    })
  }

  undo() {
    this.target.canvas.remove(this.cloneObject)
    this.target.canvas.requestRenderAll()
  }
}



// WEBPACK FOOTER //
// ./src/model/pixel/command/PasteCommand.js